import { useEffect, useState } from "react";
import { compose, count, map, sum, mean, filter, propEq, propOr, prop, is, mergeWith, flatten } from 'ramda';
import { dotPath, dotPathOr  } from 'ramda-extension';

export const CURRENCY_MAP = {'EUR': '€', undefined: '', 'USD': "$", 'GBP': '£', 'JPY': '¥', 'KRW': '₩'};
export const MONTH_MAP = { "1": "January","2": "February","3": "March","4": "April","5": "May","6": "June","7": "July","8": "August","9": "September","10": "Octomber","11": "November","12": "December" };

export const createIsActiveMap = compose(
  (params) => {
    let dt = {};
    params.map(({ dayNumber, isOpen}) => {
      dt = { ...dt, [`${dayNumber}`]: isOpen }
    });
    
    return dt; 
  },
  dotPathOr({}, 'data.posDays')
);

export const createPlannedMap = compose(
  (params) => {
    let dt = {};
    params.map(({ dayNumber, planned}) => {
      dt = { ...dt, [`${dayNumber}`]: planned }
    });
    
    return dt; 
  },
  dotPathOr({}, 'data.posDays')
);

export const sumPlannedDays = compose(
  sum,
  map(prop('planned')),
  filter((prop) => prop.isOpen),
  dotPathOr([], 'posDays')
);

export const monthlySum = (allRows, monthNumber, path) => compose(
  sum,
  map(dotPathOr([], path)),
  filter((prop)   => prop.month==monthNumber),
)(allRows);

export const monthlyAverage = (allRows, monthNumber, path) => compose(
  mean,
  map(dotPathOr([], path)),
  filter((prop) => prop.month==monthNumber),
)(allRows);

export const countOpenDays = compose(
  count((prop) => prop.isOpen),
  dotPathOr([], 'posDays')
);

export const creatMonthlyKpiState = (data) => {
  if (!data)
    return {};
  let obj = {};
  data.map((dt) => {
    obj = { ...obj, [`${dt.posId}`]: {
      averagePriceTarget: dotPathOr('0', `averagePriceTarget`, dt),
      uptTarget: dotPathOr('0', `uptTarget`, dt),
      numberOfReceiptTarget: dotPathOr('0', `numberOfReceiptTarget`, dt),
    } }
  });

  return obj;
};

export const creatTurnoverState = (data) => {
  if (!data)
    return {};
  let obj = {};
  data.map((dt) => {
    obj = { ...obj, [`${dt.userId}`]: {
      averagePrice: dotPathOr('0', `averagePrice.planned`, dt),
      upt: dotPathOr('0', `upt.planned`, dt),
      numberOfReceipt: dotPathOr('0', `numberOfReceipt.planned`, dt),
      workingDays: dotPathOr('0', `workingDays`, dt),
      planned: dotPathOr('0', `target.planned`, dt),
    } }
  });

  return obj;
};

export const saKpiTotals = (rows, path) => compose(
  mean,
  map(dotPath('actual')),
  filter((prop) => prop.planned && prop.planned > 0 && prop.actual && prop.actual > 0),
  map(dotPath(path))
)(rows);

export const targetSalesTotals = (rows, path) => compose(
  sum,
  map(dotPath(path))
)(rows);

export const targetSalesTotalsV2 = (rows, monthNumber, path) => compose(
  sum,
  map(
    compose(
      sum,
      map((prop) => { return dotPath(path, prop);}),  
      filter((prop) => prop.month == monthNumber),
    ),
  ),
  map(dotPath('periodTarget'))
)(rows);

export const targetSalesTotalsV3 = (rows, monthNumber, path) => {
  const values = rows.map((row) => {
    const months = row?.monthValues?.filter((mv) => {
      return mv?.month  == monthNumber 
    });
    const monthValue = months[0];
    return monthValue?.periodTarget.map((pt) => {
      return dotPath(path, pt);
    }); 
  });
  return sum(flatten(values));
}

export const targetSalesAverageV3 = (rows, monthNumber, path) => {
  const values = rows.map((row) => {
    const months = row?.monthValues?.filter((mv) => {
      return mv?.month  == monthNumber 
    });
    const monthValue = months[0];
    return monthValue?.periodTarget.map((pt) => {
      return dotPath(path, pt);
    }); 
  });

  return mean(flatten(values));
}

export const targetSalesAverage = (rows, path) => compose(
  mean,
  map(dotPath(path))
)(rows);

export const averageIgnoreZero = (rows, path) => compose(
  (meanNumber) =>  Math.round(meanNumber * 100) / 100,
  mean,
  map((prop) => Math.round(prop * 100) / 100 ),  
  filter((prop) => prop && prop > 0),
  map(dotPath(path))
)(rows);

export const averageRatioIgnoreZero = (rows, path) => {
  const planned = averageIgnoreZero(rows, `${path}.planned`);
  const actual = averageIgnoreZero(rows, `${path}.actual`);

  if (planned == 0)
    return 0;
  return (actual/planned) * 100;
};

export const targetSalesAverageV2 = (rows, monthNumber, path) => compose(
  mean,
  map(
    compose(
      mean,
      map((prop) => { return dotPath(path, prop);}),  
      filter((prop) => prop.month == monthNumber),
    ),
  ),
  map(dotPath('periodTarget'))
)(rows);

export const targetSalesRatio = (rows, path) => {
  const planned = targetSalesTotals(rows, `${path}.planned`);
  const actual = targetSalesTotals(rows, `${path}.actual`);

  if (planned == 0)
    return 0;
  return (actual/planned) * 100;
};

export const targetSalesRatioByAverage = (rows, path) => {
  const planned = targetSalesAverage(rows, `${path}.planned`);
  const actual = targetSalesAverage(rows, `${path}.actual`);

  if (planned == 0)
    return 0;
  return (actual/planned) * 100;
};

export const creatTargetSalesFormData = (data) => {
  if (!data)
    return {};
  let obj = {};
  data.map((dt) => {
    dt.monthValues.map((mv) => {
      const periodTarget = mv?.periodTarget;
      periodTarget.map((pt) => {
        obj = deepMerge(obj, {[`${dt.posId}`]:
          {
            [`${pt.period}`]:
            {
              budget: pt?.budget,
            }
          }
          });
      });
    });
  });

  return obj;
};

export const deepMerge = (a, b) => {
  return (is(Object, a) && is(Object, b)) ? mergeWith(deepMerge, a, b) : b;
}

export const downloadFile = async (bodyParams, fileName, downloadFn) => {
  
  const response = await downloadFn({ bodyParams });
  if (response.status != 200)
    return response.message;

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}

export function debounce(callback, wait) {
  let timeout;

  return function(...args) {
    const later = () => {
      timeout = null;
      callback(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const parsePeriodsTargets = (periodTarget) => Object.groupBy(periodTarget, ({ month }) => month)
export const getMonths = (monthValues) => monthValues.map((mv) => mv.month)

export const GetPosPeriods = (rows) => compose(
  dotPath('periodTarget'),
  // prop(0),
  // filter((r) => r.posId == posId)
)(rows);
export const GetPosMonths = (rows, posId) => compose(
  dotPath('monthValues'),
  prop(0),
  filter((r) => r.posId == posId)
)(rows);

/**
 * Format bytes as human-readable text.
 * 
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 * 
 * @return Formatted string.
 */
export function HumanFileSize(bytes, si=false, dp=1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si 
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10**dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


  return bytes.toFixed(dp) + ' ' + units[u];
}

export function choosedMonths(startMonth, endMonth)
{
  var choosedMonths = [];
  if (!endMonth)
    choosedMonths.push(startMonth + 1);
  else if (startMonth <= endMonth)
  {
    for (let i = startMonth; i <= endMonth; i++)
      choosedMonths.push(i+1);
  }

  return choosedMonths;
}

export function currencyToNumber(str)
{
  // "€ -12345.50" gives "-12345.50"
  return str.toString().replace(/[^\d.-]/g, '');
}

export const prepareParamsForPosUpdate = (elements) => {
  const params = elements.map((e) => {
    const param = {
      posId: e.posId,
      year: e.year,
      month: e.monthValues[0]?.month,
      period: e.monthValues[0]?.periodTarget[0]?.period,
      budget: parseInt(e.monthValues[0]?.periodTarget[0]?.budget) || 0,
    };
    return param;
  });

  return params;
};